<template>
    <div>
        <CRow class="mb-3 search-panel">
            <CCol xs="12" sm="1" class="form-group" style="min-width: 105px; max-width: 120px;">
                <label>Thao tác</label>
                <div class="dropdown btn-group" style="height: 36px;">
                    <button class="btn">
                        <div class="group-checkbox">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input"
                                    v-model="actionData.model.selectedAll" @change="changeSelectAll" id="selectedAll" />
                                <label class="custom-control-label" for="selectedAll"></label>
                            </div>
                        </div>
                    </button>
                    <button type="button" class="dropdown-toggle dropdown-toggle-split btn" data-toggle="dropdown"
                        aria-expanded="false" aria-haspopup="true"></button>
                    <div class="dropdown-menu">
                        <button :disabled="actionData.model.listWidgetOrgSelectedId.length === 0" class="dropdown-item"
                            @click="setupSelectOneAction('delete_list')" color="danger">
                            <CIcon name="cil-trash" style="danger" class="mr-2" />
                            Xóa tất cả
                        </button>
                    </div>
                </div>
            </CCol>
            <CCol>
                <div class="form-group">
                    <label style="color: white"></label>
                    <div style="margin-top: 10px">
                        <CButton style="float: right;margin-left: 5px;" color="primary" v-c-tooltip.hover="'Tải lại'"
                            class="btn-action-primary" @click="loadDataMainTable(true)">
                            <i class="fa fa-refresh"></i>&nbsp;&nbsp; Tải lại
                        </CButton>
                        <CButton style="float: right;" color="primary" v-c-tooltip.hover="'Thêm đơn vị sử dụng'"
                            class="btn-action-primary" @click="addOrg()">
                            <i class="fa fa-plus"></i>&nbsp;&nbsp; Thêm đơn vị sử dụng
                        </CButton>
                    </div>
                </div>
            </CCol>
        </CRow>
        <CCard class="content-fade-in mt-3p5">
            <CCardBody>
                <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource"
                    ref="mainTable">
                    <template #checkbox="{ item }">
                        <td class="group-checkbox">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input"
                                    v-model="actionData.model.listWidgetOrgSelectedId" :value="item.id" :id="item.id"
                                    v-c-tooltip.hover="'Selected'" />
                                <label class="custom-control-label" :for="item.id"></label>
                            </div>
                        </td>
                    </template>

                    <template #createDate="{ item }">
                        <td>
                            {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
                        </td>
                    </template>

                    <template #action="{ item }">
                        <td class="action-btn-group">
                            <div class="action-btn-wrapper">
                                <CButton color="danger" variant="outline" class="ml-1" square size="sm"
                                    v-c-tooltip.hover="'Xóa'" @click="
                                        setupSelectOneAction('delete_one', item.id, item.orgName)
                                    ">
                                    <CIcon name="cil-trash" />
                                </CButton>
                            </div>
                        </td>
                    </template>
                </BaseTable>
            </CCardBody>
        </CCard>
        <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping" ref="actionModal"></ModalConfirm>

        <CModal title="Thêm đơn vị sử dụng" :show.sync="isShowModelOrg" :closeOnBackdrop="false">
            <CRow class="content-fade-in">
                <CCol md="12">
                    <CForm class="form-basic">
                        <CRow>
                            <CCol sm="12" md="12" xl="12" class="mb-2">
                                <div class="form-group">
                                    <label>Đơn vị <span class="required">*</span></label>
                                    <multiselect class="mt-2" v-model="chooseOrgData.orgInput.data.model"
                                        placeholder="Chọn đơn vị" label="text" track-by="value"
                                        :options="chooseOrgData.orgInput.data.items" selectLabel="Chọn"
                                        deselectLabel="Bỏ chọn" selectedLabel="Đã chọn" :close-on-select="false"
                                        :multiple="true" :class="
                                            !(chooseOrgData.orgInput.data.validator
                                                ? chooseOrgData.orgInput.data.validator.isValid
                                                : true)
                                                ? 'input-error'
                                                : ''
                                        ">
                                        <span slot="noResult">Không có dữ liệu tương ứng!</span>
                                        <span slot="noOptions">Danh sách rỗng!</span>
                                    </multiselect>
                                    <div class="valid-error" v-show="
                                        !(chooseOrgData.orgInput.data.validator
                                            ? chooseOrgData.orgInput.data.validator.isValid
                                            : true)
                                    ">
                                        {{
                                                chooseOrgData.orgInput.data.validator
                                                    ? chooseOrgData.orgInput.data.validator.errorMessage
                                                    : ""
                                        }}
                                    </div>
                                </div>
                            </CCol>
                        </CRow>
                    </CForm>
                </CCol>
            </CRow>
            <template v-slot:footer>
                <button type="button" class="btn btn-secondary" @click="isShowModelOrg = false"><i
                        class="fa fa-times"></i> Hủy bỏ
                </button>
                <button type="button" class="btn btn-primary" @click="submitOrg()"><i class="fa fa-save"></i> Lưu
                </button>
            </template>
            <BaseLoading :loading="loadingOrg.value"></BaseLoading>
        </CModal>
    </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSwitch from "@/views/base/BaseSwitch";
import BaseSelect from "@/views/base/BaseSelect2";
import Multiselect from "vue-multiselect";
import BaseLoading from "../base/BaseFormLoading";

export default {
    name: "WidgetList",
    components: {
        BaseSwitch,
        BaseTable,
        ModalConfirm,
        BaseInput,
        BaseSelect,
        Multiselect,
        BaseLoading
    },
    notifications: {
        showSuccessMsg: {
            type: "success",
            title: "Success"
        },
        showErrorMsg: {
            type: "error",
            title: "Error"
        },
        showWarningMsg: {
            type: "warn",
            title: "warn"
        }
    },
    data() {
        let that = this;
        let actionTypeMapping = new Map();

        actionTypeMapping.set("delete_one", {
            url: "/widget-org/delete",
            titlePopup: function () {
                return that.$helper.setupTitleAction(
                    "xóa",
                    "đơn vị sử dụng",
                    that.actionData.model.widgetOrgSelectedName
                );
            },
            isJsonContentType: false,
            // type: 'PUT',
            dataSubmit: function () {
                return { id: that.actionData.model.widgetOrgSelectedId };
            },
            successCallback: function () {
                that.actionData.model.listwidgetOrgSelectedId = [];
                that.showSuccessMsg({ message: "Xóa đơn vị sử dụng " + that.actionData.model.widgetOrgSelectedName + " thành công" });
                that.loadDataMainTable();
            }
        });

        actionTypeMapping.set("delete_list", {
            url: "/widget-org/delete-list",
            titlePopup: function () {
                return that.$helper.setupTitleAction("xóa", "các đơn vị sử dụng", "đã chọn");
            },
            isJsonContentType: false,
            dataSubmit: function () {
                return {
                    lsId: that.actionData.model.listWidgetOrgSelectedId
                };
            },
            successCallback: function () {
                that.actionData.model.listWidgetOrgSelectedId = [];
                that.showSuccessMsg({ message: "Xóa danh sách đơn vị sử dụng thành công" });
                that.loadDataMainTable();
            },
        });

        return {
            labelIcon: {
                labelOn: '\u2713',
                labelOff: '\u2715'
            },
            loadingOrg: { value: false },
            isShowModelOrg: false,
            chooseOrgData: {
                orgInput: {
                    data: {
                        name: "orgIds",
                        model: [],
                        items: [],
                        validator: {
                            isValid: true,
                            errorMessage: "",
                            valid: function () {
                                let value = that.chooseOrgData.orgInput.data.model;
                                if (!value || value.length === 0) {
                                    this.isValid = false;
                                    this.errorMessage = "Đơn vị không được để trống";
                                } else {
                                    this.isValid = true;
                                }
                                return this.isValid;
                            },
                        },
                    },
                },
            },
            actionData: {
                actionTypeMapping: actionTypeMapping,
                model: {
                    selectedAll: false,
                    widgetOrgSelectedId: null,
                    widgetOrgSelectedName: null,
                    listWidgetOrgSelectedId: []
                }
            },
            idField: {
                data: {
                    model: that.$route.params.id,
                    name: "widgetId",
                },
            },
            mainTable: {
                options: {
                    fields: [
                        { key: "checkbox", label: "#" },
                        { key: "createDate", label: "Ngày tạo" },
                        { key: "orgName", label: "Đơn vị" },
                        { key: "action", label: "Thao tác" }
                    ],
                    slots: ["checkbox", "createDate", "action"],
                },
                dataSource: {
                    url: "/widget-org/page",
                    dataSubmit: function () {
                        return that.$helper.setupDataSubmit(that.$data);
                    },
                    response: function (dataResponse) {
                        return dataResponse.data;
                    }
                }
            }
        };
    },
    methods: {
        submitOrg: function () {
            let that = this;
            let isValid = that.chooseOrgData.orgInput.data.validator.valid();
            if (isValid) {
                that.loadingOrg.value = true;
                let orgIds = [];
                for(var i = 0; i < that.chooseOrgData.orgInput.data.model.length; i++){
                  orgIds.push(that.chooseOrgData.orgInput.data.model[i].value)
                }
                that.$helper.loadDataSource({
                    url: "/widget-org/add",
                    dataSubmit: function () {
                        return {
                            orgIds: orgIds,
                            widgetId: that.idField.data.model
                        };
                    },
                    successCallback: function (response) {
                        if (!that.$helper.validResponse(that.$router, response.data)) {
                            that.showErrorMsg({
                                message: that.$helper.getStringError(response.data.data),
                            });
                            that.$helper.setupErrorModel(response.data.data, that.$data);
                        } else {
                            that.showSuccessMsg({
                                message: "Thêm mới đơn vị sử dụng thành công",
                            });
                            that.isShowModelOrg = false;
                            that.loadingOrg.value = false;
                            that.loadDataMainTable();
                        }
                    },
                    errorCallback: function (error) {
                        that.$helper.handleError(that.$router, error);
                    },
                });
            }
        },
        addOrg: function () {
            let that = this;
            that.isShowModelOrg = true;
            that.loadingOrg.value = true;
            that.chooseOrgData.orgInput.data.model = [];
            that.$helper.loadDataSource({
                url: "/organization/list-org-active",
                ignoreDefaultData: true,
                successCallback: function (response) {
                    that.chooseOrgData.orgInput.data.items = response.data.data;
                    that.loadingOrg.value = false;
                },
                errorCallback: function (error) {
                    that.$helper.handleError(that.$router, error);
                },
            });
        },
        loadDataMainTable: function (isUpdateFilter) {
            this.$refs.mainTable.loadData(true, isUpdateFilter);
        },
        changeSelectAll: function (event) {
            let listWidgetOrgSelectedId = this.actionData.model.listWidgetOrgSelectedId;
            if (this.actionData.model.selectedAll) {
                this.actionData.model.listWidgetOrgSelectedId = [];

                this.$refs.mainTable.items.forEach(each => {
                    this.actionData.model.listWidgetOrgSelectedId.push(each.id);
                });
            } else {
                this.actionData.model.listWidgetOrgSelectedId = [];
            }
        },
        setupSelectOneAction: function (actionTypeKey, widgetOrgSelectedId, widgetOrgSelectedName) {
            let actionData = this.actionData.model;
            actionData.widgetOrgSelectedId = widgetOrgSelectedId || null;
            actionData.widgetOrgSelectedName = widgetOrgSelectedName || null;
            this.$refs.actionModal.setCurrAction(actionTypeKey);
        },
    },
    created: function () {
    },
    mounted() {
    },
    watch: {

    },
    computed: {}
};
</script>
<style scoped>
.td-roles {
    max-width: 250px;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>
<style>
.multiselect.input-error .multiselect__tags {
    border-color: #ff7070;
}

.vc-date {
    display: none !important;
}

.multiselect,
.multiselect .multiselect__tags {
    height: 36px !important;
    min-height: 36px !important;
}

.multiselect__input {
    line-height: unset !important;
    padding-left: 1px !important;
    font-size: 14px !important;
}

.multiselect .multiselect__tags {
    padding-top: 4px !important;
}

.multiselect .multiselect__tag {
    margin-top: 2px !important;
}
</style>